(() => {
  const config = window.AtomizedQuickView;
  if (!config?.enabled) return;

  const modal = document.querySelector('[data-atomized-quick-view]');
  if (!modal) return;

  const dialog = modal.querySelector('.atomized-quick-view__dialog');
  const content = modal.querySelector('[data-atomized-quick-view-content]');
  let opener = null;
  let activeProductUrl = null;

  const money = (cents) => `$${Math.round(Number(cents) / 100).toLocaleString('es-CL')}`;

  const close = () => {
    if (modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    content.replaceChildren();
    opener?.focus();
    opener = null;
  };

  const updateVariant = (root) => {
    const variants = JSON.parse(root.querySelector('[data-qv-variants]').textContent);
    const variantId = root.dataset.selectedVariantId;
    const variant = variants.find((item) => String(item.id) === variantId);
    if (!variant) return;

    root.querySelector('[data-qv-price]').textContent = money(variant.price);
    root.querySelectorAll('[data-qv-variant-price]').forEach((price) => {
      price.textContent = money(price.dataset.variantPriceCents);
    });
    const compare = root.querySelector('[data-qv-compare-price]');
    compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
    compare.hidden = !(variant.compare_at_price > variant.price);

    const available = root.querySelector('[data-qv-availability]');
    const add = root.querySelector('[data-qv-add]');
    available.textContent = variant.available ? 'Disponible' : 'Agotado';
    available.classList.toggle('is-unavailable', !variant.available);
    add.disabled = !variant.available;
    root.querySelector('[data-qv-add-text]').textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
    const lowStock = root.querySelector('[data-qv-low-stock]');
    const lowStockCount = root.querySelector('[data-qv-low-stock-count]');
    const inventory = Number(variant.inventory_quantity);
    const showLowStock = variant.available && variant.inventory_management && inventory > 0 && inventory <= 4;
    lowStock.classList.toggle('is-hidden', !showLowStock);
    lowStockCount.textContent = showLowStock ? inventory : '';
    root.querySelectorAll('[data-qv-variant-card]').forEach((card) => card.classList.toggle('is-active', card.dataset.variantId === String(variant.id)));
    const selectedCard = root.querySelector(`[data-qv-variant-card][data-variant-id="${variant.id}"]`);
    const image = selectedCard?.dataset.variantImage;
    if (image) {
      const mainImage = root.querySelector('[data-qv-main-image]');
      if (mainImage) mainImage.src = image;
    }
  };

  const addToCart = async (root) => {
    const error = root.querySelector('[data-qv-error]');
    const add = root.querySelector('[data-qv-add]');
    const spinner = root.querySelector('[data-qv-spinner]');
    error.hidden = true;
    add.disabled = true;
    spinner.hidden = false;

    const formData = new FormData();
    formData.append('id', root.dataset.selectedVariantId);
    formData.append('quantity', Math.max(1, Number(root.querySelector('[data-qv-quantity]').value) || 1));
    const cart = document.querySelector('cart-notification, cart-drawer');
    if (cart?.getSectionsToRender) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(opener || document.activeElement);
    }

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || window.cartStrings?.error || 'No fue posible agregar el producto.');
      close();
      if (cart?.renderContents) cart.renderContents(result);
      else window.location.assign(window.routes.cart_url);
    } catch (exception) {
      error.textContent = exception.message;
      error.hidden = false;
      updateVariant(root);
    } finally {
      spinner.hidden = true;
      if (!modal.hidden) updateVariant(root);
    }
  };

  const bindProduct = () => {
    const root = content.querySelector('[data-atomized-quick-view-product]');
    if (!root) return;
    const quantity = root.querySelector('[data-qv-quantity]');
    root.dataset.selectedVariantId = root.querySelector('[data-qv-variant-card].is-active')?.dataset.variantId || root.querySelector('[data-qv-variant-card]')?.dataset.variantId;
    root.querySelectorAll('[data-qv-variant-card]').forEach((card) => card.addEventListener('click', () => {
      if (card.disabled) return;
      root.dataset.selectedVariantId = card.dataset.variantId;
      updateVariant(root);
    }));
    root.querySelector('[data-qv-quantity-decrease]').addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) - 1); });
    root.querySelector('[data-qv-quantity-increase]').addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) + 1); });
    quantity.addEventListener('change', () => { quantity.value = Math.max(1, Number(quantity.value) || 1); });
    root.querySelector('[data-qv-add]').addEventListener('click', () => addToCart(root));
    root.querySelectorAll('[data-qv-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      const image = root.querySelector('[data-qv-main-image]');
      if (image) { image.src = thumb.dataset.qvImageSrc; image.alt = thumb.dataset.qvImageAlt || ''; }
    }));
    updateVariant(root);
  };

  const open = async (trigger) => {
    const productUrl = trigger.dataset.productUrl;
    if (!productUrl || activeProductUrl === productUrl) return;
    activeProductUrl = productUrl;
    opener = trigger;
    trigger.setAttribute('aria-busy', 'true');
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', 'atomized-quick-view-product');
    try {
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('No se pudo cargar el producto.');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = html.querySelector('[data-atomized-quick-view-product]');
      if (!product) throw new Error('La vista rápida no está disponible para este producto.');
      content.replaceChildren(product);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      bindProduct();
      dialog.focus();
    } catch (exception) {
      console.error('Atomized quick view:', exception);
      window.location.assign(productUrl);
    } finally {
      activeProductUrl = null;
      trigger.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-atomized-quick-view-trigger]');
    if (trigger) { event.preventDefault(); open(trigger); }
  });
  modal.querySelectorAll('[data-atomized-quick-view-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !modal.hidden) close(); });
})();
